<template>
  <div>
    <div class="relative">
      <picture>
        <source srcset="/img/lp/lpFondiAvatarMore.webp" type="image/webp" />
        <source srcset="/img/lp/lpFondiAvatarMore.png" type="image/png" />
        <img src="/img/lp/lpFondiAvatarMore.png" class="img-avatars" />
      </picture>
      <div class="area-box-wrapper">
        <div :class="`area-box area-plaza ${$i18n.locale}`">
          <picture>
            <source srcset="/img/lp/lpAreaImagePlaza.webp" type="image/webp" />
            <source srcset="/img/lp/lpAreaImagePlaza.png" type="image/png" />
            <img src="/img/lp/lpAreaImagePlaza.png" />
          </picture>
          <v-layout justify-center align-center fill-height>{{ $t('lp.phrases.plaza') }}</v-layout>
        </div>
        <div v-if="showLiving" :class="`area-box area-living ${$i18n.locale}`">
          <picture>
            <source srcset="/img/lp/lpAreaImageLounge.webp" type="image/webp" />
            <source srcset="/img/lp/lpAreaImageLounge.png" type="image/png" />
            <img src="/img/lp/lpAreaImageLounge.png" />
          </picture>
          <v-layout justify-center align-center fill-height>{{ $t('lp.phrases.living') }}</v-layout>
        </div>
        <div :class="`area-box area-myroom ${$i18n.locale}`">
          <picture>
            <source srcset="/img/lp/lpAreaImageHome.webp" type="image/webp" />
            <source srcset="/img/lp/lpAreaImageHome.png" type="image/png" />
            <img src="/img/lp/lpAreaImageHome.png" />
          </picture>
          <v-layout justify-center align-center fill-height>{{ $t('lp.phrases.myroom') }}</v-layout>
        </div>
      </div>
      <div :class="`area-text ${$i18n.locale}`">{{ $t('lp.immerse') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['showLiving'],
};
</script>

<style scoped>
.img-avatars {
  width: 600px;
}
.area-box-wrapper {
  margin-top: -56px;
}
.area-box {
  position: relative;
  display: inline-block;
  vertical-align: top;
  height: 360px;
  width: 360px;
  background-size: contain;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.2em;
  color: #fff;
  text-shadow: 0px 0px 14px rgb(0, 0, 0);
  white-space: pre-wrap;
}
.area-box.ja {
  font-size: 32px;
  height: 330px;
  width: 330px;
}
.area-box:first-child {
  margin-right: 36px;
}
.area-box:nth-child(2):not(:last-child) {
  margin-left: -60px;
  margin-right: -24px;
}
.area-box > picture {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.area-box > picture > source,
.area-box > picture > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.area-box > .layout {
  position: relative;
}
.area-box.area-plaza {
  z-index: 1;
}
.area-box.area-living {
  z-index: 2;
}
.area-box.area-myroom {
  z-index: 3;
}
.area-text {
  position: relative;
  width: max-content;
  margin: 36px auto 0;
  color: #73674e;
  font-size: 35px;
  font-weight: bold;
}
.area-text.ja {
  font-size: 38px;
  font-weight: 600;
}
.area-text::before {
  content: '';
  position: absolute;
  height: 8px;
  bottom: -6px;
  left: -40px;
  right: -40px;
  border-radius: 4px;
  background-image: url('/img/lp/lpTextUnderLineShort.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-size: cover;
  background-position: right;
}
.area-text::after {
  content: '';
  position: absolute;
  top: 0;
  right: -70px;
  width: 52px;
  height: 43px;
  background-image: url('/img/lp/lpTextUnderLineMiddleAccent.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
  background-position: center;
}
@media (max-width: 1200px) {
  .area-box,
  .area-box.ja {
    height: 240px;
    width: 240px;
    font-size: 16px;
  }
  .area-box.ja {
    font-size: 20px;
  }
}
@media (max-width: 1023px) {
  .img-avatars {
    width: 420px;
  }
  .area-text {
    font-size: 18px;
  }
  .area-text.ja {
    font-size: 18px;
  }
  .area-text::before {
    bottom: -6px;
    left: -20px;
    right: -20px;
    height: 6px;
  }
  .area-text::after {
    width: 30px;
    height: 24px;
    right: -36px;
  }
}
@media (max-width: 767px) {
  .img-avatars {
    width: 320px;
  }
  .area-box,
  .area-box.ja {
    height: 120px;
    width: 120px;
    font-size: 12px;
    text-shadow: 0px 0px 4px rgb(0, 0, 0);
  }
  .area-box.ja {
    font-size: 12px;
  }
  .area-box:first-child {
    margin-right: 18px;
  }
  .area-box:nth-child(2):not(:last-child) {
    margin-left: -30px;
    margin-right: -12px;
  }
  .area-text {
    font-size: 16px;
    margin-top: 16px;
  }
  .area-text.ja {
    font-size: 14px;
  }
  .area-text::before {
    right: -6px;
    left: -6px;
    height: 4px;
    bottom: -4px;
  }
  .area-text::after {
    width: 24px;
    height: 19px;
    right: -25px;
    top: -2px;
  }
}
@media (max-width: 360px) {
  .area-box,
  .area-box.ja {
    height: 100px;
    width: 100px;
    font-size: 10px;
  }
  .area-box > .layout {
    transform: scale(0.8);
    width: 110%;
    margin-left: -5%;
  }
  .area-box.ja > .layout {
    transform: scale(1);
    width: unset;
    margin-left: unset;
  }
  .area-text {
    font-size: 13px;
  }
}
</style>
